/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useEffect } from 'react';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';

const TableComponent = ({
  setSelectedRow,
  searchByDrugNameTableData,
  setGridApi,
  gridApi,
  columnName,
  rowSelection,
  fullScreenView,
  onSelect,
  emptyTableError,
  frameworkComponents,
  handleFullScreenView,
  handleFullScreenViewClick,
  fileName,
  gridHeight,
  exportFile,
  setShowErrorMsg,
}) => {
  const onSelectionChanged = useCallback((e) => {
    setSelectedRow(e.api.getSelectedRows());
  }, []);

  useEffect(() => {
    gridApi && gridApi.setFilterModel(null);
  }, [gridApi]);

  const gridCall = useCallback((params) => {
    setGridApi(params.api);
  }, []);

  return (
    <>
      <div className="table-container mt-2">
        <DisplayErrorMessages errorMessages={emptyTableError || []} />
        <Grid
          rowData={searchByDrugNameTableData}
          columnDefs={columnName}
          defaultCol={{ editable: false }}
          rowSelection={rowSelection}
          onSelectionChanged={(e) => onSelectionChanged(e)}
          frameworkComponents={frameworkComponents}
          handleFullScreenView={handleFullScreenView}
          exportFile={exportFile}
          gridHeight={gridHeight}
          onSelect={onSelect}
          fullScreenView={fullScreenView}
          handleFullScreenViewClick={handleFullScreenViewClick}
          fileName={fileName}
          gridCall={(data) => gridCall(data)}
        />
      </div>
    </>
  );
};

export default TableComponent;
